import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dialog, MenuItem, FlatButton, IconMenu, IconButton } from 'material-ui';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { grey400 } from 'material-ui/styles/colors';
import {
    EDIT_NEWS_PAGE,
    NEWS_LIST_PAGE,
    NEWS_MIME_MEDIA_LIST_PAGE,
    EDIT_NEWS_MEDIA_PAGE,
    ADD_NEWS_PAGE,
} from '../../constants/routes';
import AdminService, { ADMIN } from '../../services/admin';
import style from '../../styles/styles';
import styles from './NewsPage.css';
import ModuleService from '../../services/module';
import {
    deleteOneNews,
    fetchOneNews,
    getOneNews,
    postOneNewsMedia,
} from '../../store/news/actions';
import { fetchApp } from '../../store/apps/actions';
import { getTypes } from '../../store/types/actions';
import { deleteComment } from '../../store/comments/actions';
import { getCustomFields } from '../../store/customfields/actions';
import withTranslation from '../../hoc/withTranslation';
import Error from '../../components/common/Error/Error';
import Loading from '../../components/common/Loading/Loading';
import NewsInfo from '../../components/news/NewsInfo';
import MediaBlocs from '../../components/media/MediaBlocs/MediaBlocs';
import CommentList from '../../components/comment/CommentList/CommentList';
import DumbTypeList from '../../components/type/DumbTypeList/DumbTypeList';
import { EXTERNAL } from '../../constants/sources';
import ImportIndicator from '../../components/import/ImportIndicator';
import CommentService from '../../services/comment';

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class NewsPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        news: PropTypes.object,
    };

    static defaultProps = {};

    state = {
        openRemoveNews: false,
        commentToDelete: null,
        openDeleteComment: false,
    };

    componentWillMount() {
        this.fetch();
        if (this.props.app) {
            this.props.getTypes(this.props.app.id, this.props.currentLang);
            this.props.getCustomFields(this.props.app.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match
            || this.props.currentLang !== nextProps.currentLang) {
            this.fetch(
                nextProps.match.params.appId,
                nextProps.match.params.newsId,
                nextProps.currentLang,
            );
        }
        if (this.props.sending && !nextProps.sending) {
            if (!nextProps.news) { // News has been deleted
                this.props.history.push(NEWS_LIST_PAGE.replace(':appId', this.props.app.id));
            }
        }
        if (this.props.commentSending && !nextProps.commentSending) {
            this.handleCloseDeleteComment();
            this.getOneNews();
        }
        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getTypes(nextProps.app.id, nextProps.currentLang);
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    // Delete news

    handleOpenNews = () => {
        this.setState({ openRemoveNews: true });
    };

    handleCloseNews = () => {
        this.setState({ openRemoveNews: false });
    };

    deleteNews = () => {
        this.props.deleteOneNews(this.props.app.id, this.props.news.id, this.props.currentLang);
    };

    selectMime = (mime) => {
        let url = NEWS_MIME_MEDIA_LIST_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':newsId', this.props.news.id)
            .replace(':shortMime', mime);
        this.props.history.push(url);
    };

    editMedia = (mediaId) => {
        let url = EDIT_NEWS_MEDIA_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':newsId', this.props.news.id)
            .replace(':mediaId', mediaId);
        this.props.history.push(url);
    };

    // Delete comment

    handleDeleteComment = (comment) => {
        this.setState({
            openDeleteComment: true,
            commentToDelete: comment,
        });
    };

    handleCloseDeleteComment = () => {
        this.setState({
            openDeleteComment: false,
            commentToDelete: null,
        });
    };

    deleteComment = () => {
        this.props.deleteComment(this.props.app.id, this.state.commentToDelete.id);
    };

    // Fetch

    fetch(appId = null, newsId = null, lang = null) {
        this.fetchApplication(appId);
        this.fetchOneNews(appId, newsId, lang);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    fetchOneNews(appId = null, newsId = null, fetchLang = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const news = newsId || this.props.match.params.newsId;
            const lang = fetchLang || this.props.currentLang;

            if (app && news) {
                this.props.fetchOneNews(app, news, lang);
            }
        }
    }

    getOneNews(appId = null, newsId = null, fetchLang = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const news = newsId || this.props.match.params.newsId;
            const lang = fetchLang || this.props.currentLang;

            if (app && news) {
                this.props.getOneNews(app, news, lang);
            }
        }
    }

    // Render

    renderMenu() {
        let menu;

        if (AdminService.isAuthorized(ADMIN, this.props.user)) {
            menu = (
                <IconMenu
                    style={styles.buttons}
                    iconButtonElement={iconButtonElement}
                    anchorOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}
                    targetOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}
                >
                    <Link
                        to={{
                            pathname: ADD_NEWS_PAGE
                                .replace(':appId', this.props.app.id),
                            state: { isDuplicate: true },
                        }}
                    >
                        <MenuItem>
                            {this.props.t('generic.duplicate')}
                        </MenuItem>
                    </Link>
                    <Link
                        to={EDIT_NEWS_PAGE.replace(':appId', this.props.app.id).replace(
                            ':newsId',
                            this.props.news.id,
                        )}
                    >
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                    <MenuItem onClick={this.handleOpenNews}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                </IconMenu>
            );
        }

        return menu;
    };

    renderDeleteCommentDialog(comment) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.commentSending}
                onClick={this.handleCloseDeleteComment}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.commentSending}
                onClick={this.deleteComment}
            />,
        ];
        const text = CommentService.getTextForComment(
            this.props.t,
            comment,
            'module.comment.delete_comment_confirmation'
        );
        return (
            <Dialog
                actions={actions}
                title={this.props.t('module.comment.reject_comment')}
                modal={this.props.commentSending}
                open={this.state.openDeleteComment}
                onRequestClose={this.handleCloseDeleteComment}
            >
                {this.props.commentSending && <Loading paper={false} />}
                {!this.props.commentSending &&
                    <p>
                        <div dangerouslySetInnerHTML={{ __html: text }} />
                    </p>
                }
            </Dialog>
        );
    }

    renderDeleteNewsDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseNews}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteNews}
            />,
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemoveNews}
                onRequestClose={this.handleCloseNews}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                    <p>{this.props.t('module.news.delete_news_confirmation')}</p>
                }
            </Dialog>
        );
    }

    renderInformation() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <NewsInfo
                    news={this.props.news}
                    customFields={this.props.customFields}
                />
            </div>
        );
    }

    renderTypes() {
        const types = this.props.types.filter((type) => {
            return this.props.news.types_id.includes(type.id);
        });

        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <DumbTypeList
                    title={this.props.t('generic.types')}
                    types={types}
                    loading={this.props.typesPending}
                />
            </div>
        );
    }

    renderMedias() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <MediaBlocs
                    app={this.props.app}
                    entity={this.props.news}
                    medias={this.props.news.medias || []}
                    pendingMedias={this.props.pendingMedias}
                    postMedia={this.props.postOneNewsMedia}
                    selectMime={this.selectMime}
                    uploadedMedias={this.props.uploadedMedias}
                    failedMedias={this.props.failedMedias}
                    currentLang={this.props.currentLang}
                />
            </div>
        );
    }

    renderComment() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <CommentList
                    title={this.props.t('generic.comments')}
                    user={this.props.user}
                    comments={this.props.news.comments}
                    handleDeleteComment={this.handleDeleteComment}
                />
            </div>

        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.news) {
            return <Loading paper={false} />;
        } else {
            return (
                <div style={styles.container}>
                    {this.props.news.source === EXTERNAL
                        ? <ImportIndicator />
                        : null}
                    {this.renderMenu()}
                    {this.renderDeleteNewsDialog()}
                    {this.state.commentToDelete
                        && this.renderDeleteCommentDialog(this.state.commentToDelete)}
                    <h3 style={style.navigation}>
                        {this.props.t('module.news.name')} / {this.props.t('generic.detail')} - {this.props.news.title}
                    </h3>
                    <div className="row">
                        {this.renderInformation()}
                        {this.renderTypes()}
                        {this.renderMedias()}
                        {ModuleService.hasModule(this.props.app, ModuleService.COMMENTS)
                            && this.renderComment()}
                    </div>

                </div>
            );
        }
    }

}

function mapStateToProps(state, ownProps) {
    return {
        error: state.apps.error || state.news.error,
        user: state.auth.content,
        loading: state.apps.pending || state.news.pending || state.customFields.pending,
        sending: state.news.sending,
        news: state.news.currentNews,
        currentLang: state.ui.currentLang,
        app: state.apps.currentApplication,
        pendingMedias: state.news.pendingMedias,
        uploadedMedias: state.news.uploadedMedias,
        failedMedias: state.news.failedMedias,
        currentMedia: state.news.currentMedia,
        types: state.types.content,
        typesPending: state.types.pending,
        commentSending: state.comments.sending,
        customFields: state.customFields.content,
    };
}

export default connect(mapStateToProps, {
    deleteComment,
    fetchApp,
    fetchOneNews,
    getOneNews,
    postOneNewsMedia,
    getCustomFields,
    getTypes,
    deleteOneNews,
})(withTranslation(NewsPage));



// WEBPACK FOOTER //
// src/containers/news/NewsPage.js